export const MOBILE_MAX_WIDTH = 744;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

export const isMobileViewport = () =>
  window.matchMedia(MOBILE_MEDIA_QUERY).matches;

export const PDP_GALLERY_IMAGE_SIZES =
  `(max-width: ${MOBILE_MAX_WIDTH}px) 100vw, `
  + '(max-width: 1023px) 50vw, min(54vw, 920px)';
